import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { BaseComponent } from "@bt/core/base";
import { GeoModel, GeoService} from "@bt/core";
import { NotifierService } from "angular-notifier";
import { Router, ActivatedRoute } from "@angular/router";


@Component({
  selector: 'app-geo-editor',
  templateUrl: './geo-editor.component.html',
  styleUrls: ['./geo-editor.component.scss']
})
export class GeoEditorComponent extends BaseComponent implements OnInit {

  geoModel: GeoModel;
  public validForm: FormGroup;
  notifier: any;

  constructor(
    private geoService: GeoService,
    private fb: FormBuilder,
    notifierService: NotifierService,
    private router: Router,
    private activeRoute: ActivatedRoute,
  ) {
    super();
    this.notifier = notifierService;
   }

  ngOnInit() {

    var id = this.activeRoute.snapshot.paramMap.get('id');
    this.geoModel = new GeoModel();
    if (id) {
      this.loadGeoToEdit(id);

    }

    this.validForm = this.fb.group({
      geoName:     ["", [Validators.required, Validators.maxLength(50), Validators.minLength(3)]],
      
    });
  }

  get geoName() { return this.validForm.get('geoName'); }

  public loadGeoToEdit(id: string) {
    var t = this;
    t.setLoading(true);

    t.geoService.getGeoToEdit(id)
      .then((resp) => {
        t.geoModel = resp.data;
        t.setLoading(false);
      })
      .catch((error) => {
        t.notifier.notify('error', 'Ошибка подгрузки данных');
        t.router.navigateByUrl("app/push-notification");
        t.setLoading(false);
      });
  }

  CreateGeo(geoModel: GeoModel){
    this.setLoading(true);
    if (!this.validForm.valid) {
      this.setLoading(false);
      this.notifier.notify('error', "Проверьте корректность данных");
      this.markFormGroupTouchedAndDirty(this.validForm);
      return;
    }
    this.geoService.CreateGeo(geoModel)
    .then((resp) => {
      if (resp) {
        this.notifier.notify('success', 'Успешно сохранено');
        this.router.navigateByUrl('app/geo');
      }
      else {
        this.notifier.notify('error', 'Ошибка при сохранении гео');
      }
      this.setLoading(false);
    })
    .catch((responce)=>{
      var text = this.GetErrorMessageText("Не удалось сохранить данные гео", responce);
      this.notifier.notify('error', text);

      this.setLoading(false);
    });
  }

  goBack() {
    this.router.navigateByUrl('app/geo');
  }


}



// WEBPACK FOOTER //
// ./src/app/geo/geo-editor/geo-editor.component.ts